export default class SliderPosts
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      main: 'data-slider-posts',
      wrapper: 'data-slider-posts-wrapper',
      item: 'data-slider-posts-item',
      arrows: 'data-slider-posts-arrows',
      arrowLeft: 'data-slider-posts-arrow-left',
      arrowRight: 'data-slider-posts-arrow-right',
      dots: 'data-slider-posts-dots',
      dot: 'data-slider-posts-dot',
    };
    
    this.sliders = document.querySelectorAll(`[${this.settings.main}]`);
    if (!this.sliders) return;
    
    return true;
  }
  
  setEvents()
  {
    this.sliders.forEach(elWrapper => {
      const wrapper = elWrapper.querySelector(`[${this.settings.wrapper}]`);
      const children = wrapper.querySelectorAll(`[${this.settings.item}]`)
      
      const settings = {
        container: wrapper,
        controls: false,
        slideBy: 1,
        autoplayText: ['', ''],
        autoplay: false,
        loop: false,
        touch: true,
        center: children.length < 4,
        mouseDrag: true,
        nav: false,
        gutter: 17,
        navPosition: 'bottom',
        items: 4,
        responsive: {
          320: {
            items: 1,
            touch: true,
          },
          767: {
            items: 2,
            mouseDrag: true,
          },
          1023: {
            items: 4,
            loop: false,
          }
        }
      };
      
      const slider = this.initSlider(settings);
      const arrowRight = elWrapper.querySelector(`[${this.settings.arrowRight}]`);
      const arrowLeft = elWrapper.querySelector(`[${this.settings.arrowLeft}]`);
      
      if (arrowRight) {
        arrowRight.addEventListener('click', () => {
          slider.goTo('next');
        });
      }
      
      if (arrowLeft) {
        arrowLeft.addEventListener('click', () => {
          slider.goTo('prev');
        });
      }
  
      slider.events.on('indexChanged', (info) => {
        elWrapper.querySelectorAll(`[${this.settings.dot}]`).removeClass('active');
        elWrapper.querySelector(`[${this.settings.dot}="${info.displayIndex - 1}"]`).addClass('active');
      });
  
      elWrapper.querySelectorAll(`[${this.settings.dot}]`).forEach((dot) => {
        dot.addEventListener('click', (e) => {
          const numberSlide = parseInt(e.target.getAttribute(this.settings.dot));
          slider.goTo(numberSlide);
        })
      });
    })
  }
  
  initSlider(settings) {
    return tns(settings);
  }
}
